import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @closeModal={{@closeModal}}
  @flash={{this.flash}}
  @flashType={{this.flashType}}
  @title={{i18n this.header}}
  class="sidebar-section-form-modal"
>
  <:body>
    <form class="form-horizontal sidebar-section-form">
      {{#unless this.transformedModel.hideTitleInput}}
        <div class="sidebar-section-form__input-wrapper">
          <label for="section-name">
            {{i18n "sidebar.sections.custom.title.label"}}
          </label>

          <Input
            name="section-name"
            @type="text"
            @value={{this.transformedModel.title}}
            class={{this.transformedModel.titleCssClass}}
            id="section-name"
            {{on
              "input"
              (with-event-value (fn (mut this.transformedModel.title)))
            }}
          />

          {{#if this.transformedModel.invalidTitleMessage}}
            <div class="title warning">
              {{this.transformedModel.invalidTitleMessage}}
            </div>
          {{/if}}
        </div>
      {{/unless}}
      <div
        role="table"
        aria-rowcount={{this.activeLinks.length}}
        class="sidebar-section-form__links-wrapper"
      >

        <div class="row-wrapper header" role="row">
          <div
            class="input-group link-icon"
            role="columnheader"
            aria-sort="none"
          >
            <label>{{i18n "sidebar.sections.custom.links.icon.label"}}</label>
          </div>

          <div
            class="input-group link-name"
            role="columnheader"
            aria-sort="none"
          >
            <label>{{i18n "sidebar.sections.custom.links.name.label"}}</label>
          </div>

          <div
            class="input-group link-url"
            role="columnheader"
            aria-sort="none"
          >
            <label>{{i18n "sidebar.sections.custom.links.value.label"}}</label>
          </div>
        </div>

        {{#each this.activeLinks as |link|}}
          <Sidebar::SectionFormLink
            @link={{link}}
            @deleteLink={{this.deleteLink}}
            @reorderCallback={{this.reorder}}
            @setDraggedLinkCallback={{this.setDraggedLink}}
          />
        {{/each}}

      </div>
      <DButton
        @action={{this.addLink}}
        @title="sidebar.sections.custom.links.add"
        @icon="plus"
        @label="sidebar.sections.custom.links.add"
        @ariaLabel="sidebar.sections.custom.links.add"
        class="btn-flat btn-text add-link"
      />

      {{#if this.transformedModel.sectionType}}
        <hr />
        <h3>{{i18n "sidebar.sections.custom.more_menu"}}</h3>
        {{#each this.activeSecondaryLinks as |link|}}
          <Sidebar::SectionFormLink
            @link={{link}}
            @deleteLink={{this.deleteLink}}
            @reorderCallback={{this.reorder}}
            @setDraggedLinkCallback={{this.setDraggedLink}}
          />
        {{/each}}
        <DButton
          @action={{this.addSecondaryLink}}
          @title="sidebar.sections.custom.links.add"
          @icon="plus"
          @label="sidebar.sections.custom.links.add"
          @ariaLabel="sidebar.sections.custom.links.add"
          class="btn-flat btn-text add-link"
        />
      {{/if}}
    </form>
  </:body>
  <:footer>
    <DButton
      @action={{this.save}}
      @label="sidebar.sections.custom.save"
      @ariaLabel="sidebar.sections.custom.save"
      @disabled={{not this.transformedModel.valid}}
      id="save-section"
      class="btn-primary"
    />
    {{#if (and this.currentUser.admin)}}
      <div
        class="mark-public-wrapper
          {{if this.transformedModel.sectionType '-disabled'}}"
      >
        <label class="checkbox-label">
          {{#if this.transformedModel.sectionType}}
            <DTooltip
              @content={{i18n "sidebar.sections.custom.always_public"}}
              class="always-public-tooltip"
            >
              <:trigger>
                {{d-icon "check-square"}}
                <span>{{i18n "sidebar.sections.custom.public"}}</span>
              </:trigger>
            </DTooltip>
          {{else}}
            <Input
              @type="checkbox"
              @checked={{this.transformedModel.public}}
              class="mark-public"
              disabled={{this.transformedModel.sectionType}}
            />
            <span>{{i18n "sidebar.sections.custom.public"}}</span>
          {{/if}}
        </label>
      </div>
    {{/if}}
    {{#if this.canDelete}}
      <DButton
        @icon="trash-alt"
        @action={{this.delete}}
        @label="sidebar.sections.custom.delete"
        @ariaLabel="sidebar.sections.custom.delete"
        id="delete-section"
        class="btn-danger delete"
      />
    {{/if}}
    {{#if this.transformedModel.sectionType}}
      <DButton
        @action={{this.resetToDefault}}
        @icon="undo"
        @title="sidebar.sections.custom.links.reset"
        @label="sidebar.sections.custom.links.reset"
        @ariaLabel="sidebar.sections.custom.links.reset"
        class="btn-flat btn-text reset-link"
      />
    {{/if}}
  </:footer>
</DModal>
*/
{
  "id": "WpctES88",
  "block": "[[[8,[39,0],[[24,0,\"sidebar-section-form-modal\"]],[[\"@closeModal\",\"@flash\",\"@flashType\",\"@title\"],[[30,1],[30,0,[\"flash\"]],[30,0,[\"flashType\"]],[28,[37,1],[[30,0,[\"header\"]]],null]]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[10,\"form\"],[14,0,\"form-horizontal sidebar-section-form\"],[12],[1,\"\\n\"],[41,[51,[30,0,[\"transformedModel\",\"hideTitleInput\"]]],[[[1,\"        \"],[10,0],[14,0,\"sidebar-section-form__input-wrapper\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,\"for\",\"section-name\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"sidebar.sections.custom.title.label\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[8,[39,3],[[24,3,\"section-name\"],[16,0,[30,0,[\"transformedModel\",\"titleCssClass\"]]],[24,1,\"section-name\"],[4,[38,4],[\"input\",[28,[37,5],[[28,[37,6],[[28,[37,7],[[30,0,[\"transformedModel\",\"title\"]]],null]],null]],null]],null]],[[\"@type\",\"@value\"],[\"text\",[30,0,[\"transformedModel\",\"title\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"transformedModel\",\"invalidTitleMessage\"]],[[[1,\"            \"],[10,0],[14,0,\"title warning\"],[12],[1,\"\\n              \"],[1,[30,0,[\"transformedModel\",\"invalidTitleMessage\"]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[10,0],[14,\"role\",\"table\"],[15,\"aria-rowcount\",[30,0,[\"activeLinks\",\"length\"]]],[14,0,\"sidebar-section-form__links-wrapper\"],[12],[1,\"\\n\\n        \"],[10,0],[14,0,\"row-wrapper header\"],[14,\"role\",\"row\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"input-group link-icon\"],[14,\"role\",\"columnheader\"],[14,\"aria-sort\",\"none\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,[28,[35,1],[\"sidebar.sections.custom.links.icon.label\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,0],[14,0,\"input-group link-name\"],[14,\"role\",\"columnheader\"],[14,\"aria-sort\",\"none\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,[28,[35,1],[\"sidebar.sections.custom.links.name.label\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,0],[14,0,\"input-group link-url\"],[14,\"role\",\"columnheader\"],[14,\"aria-sort\",\"none\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,[28,[35,1],[\"sidebar.sections.custom.links.value.label\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n\"],[42,[28,[37,10],[[28,[37,10],[[30,0,[\"activeLinks\"]]],null]],null],null,[[[1,\"          \"],[8,[39,11],null,[[\"@link\",\"@deleteLink\",\"@reorderCallback\",\"@setDraggedLinkCallback\"],[[30,2],[30,0,[\"deleteLink\"]],[30,0,[\"reorder\"]],[30,0,[\"setDraggedLink\"]]]],null],[1,\"\\n\"]],[2]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,12],[[24,0,\"btn-flat btn-text add-link\"]],[[\"@action\",\"@title\",\"@icon\",\"@label\",\"@ariaLabel\"],[[30,0,[\"addLink\"]],\"sidebar.sections.custom.links.add\",\"plus\",\"sidebar.sections.custom.links.add\",\"sidebar.sections.custom.links.add\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"transformedModel\",\"sectionType\"]],[[[1,\"        \"],[10,\"hr\"],[12],[13],[1,\"\\n        \"],[10,\"h3\"],[12],[1,[28,[35,1],[\"sidebar.sections.custom.more_menu\"],null]],[13],[1,\"\\n\"],[42,[28,[37,10],[[28,[37,10],[[30,0,[\"activeSecondaryLinks\"]]],null]],null],null,[[[1,\"          \"],[8,[39,11],null,[[\"@link\",\"@deleteLink\",\"@reorderCallback\",\"@setDraggedLinkCallback\"],[[30,3],[30,0,[\"deleteLink\"]],[30,0,[\"reorder\"]],[30,0,[\"setDraggedLink\"]]]],null],[1,\"\\n\"]],[3]],null],[1,\"        \"],[8,[39,12],[[24,0,\"btn-flat btn-text add-link\"]],[[\"@action\",\"@title\",\"@icon\",\"@label\",\"@ariaLabel\"],[[30,0,[\"addSecondaryLink\"]],\"sidebar.sections.custom.links.add\",\"plus\",\"sidebar.sections.custom.links.add\",\"sidebar.sections.custom.links.add\"]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"]],[]],[[[1,\"\\n    \"],[8,[39,12],[[24,1,\"save-section\"],[24,0,\"btn-primary\"]],[[\"@action\",\"@label\",\"@ariaLabel\",\"@disabled\"],[[30,0,[\"save\"]],\"sidebar.sections.custom.save\",\"sidebar.sections.custom.save\",[28,[37,13],[[30,0,[\"transformedModel\",\"valid\"]]],null]]],null],[1,\"\\n\"],[41,[28,[37,14],[[30,0,[\"currentUser\",\"admin\"]]],null],[[[1,\"      \"],[10,0],[15,0,[29,[\"mark-public-wrapper\\n          \",[52,[30,0,[\"transformedModel\",\"sectionType\"]],\"-disabled\"]]]],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"checkbox-label\"],[12],[1,\"\\n\"],[41,[30,0,[\"transformedModel\",\"sectionType\"]],[[[1,\"            \"],[8,[39,15],[[24,0,\"always-public-tooltip\"]],[[\"@content\"],[[28,[37,1],[\"sidebar.sections.custom.always_public\"],null]]],[[\"trigger\"],[[[[1,\"\\n                \"],[1,[28,[35,16],[\"check-square\"],null]],[1,\"\\n                \"],[10,1],[12],[1,[28,[35,1],[\"sidebar.sections.custom.public\"],null]],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"            \"],[8,[39,3],[[24,0,\"mark-public\"],[16,\"disabled\",[30,0,[\"transformedModel\",\"sectionType\"]]]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"transformedModel\",\"public\"]]]],null],[1,\"\\n            \"],[10,1],[12],[1,[28,[35,1],[\"sidebar.sections.custom.public\"],null]],[13],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"canDelete\"]],[[[1,\"      \"],[8,[39,12],[[24,1,\"delete-section\"],[24,0,\"btn-danger delete\"]],[[\"@icon\",\"@action\",\"@label\",\"@ariaLabel\"],[\"trash-alt\",[30,0,[\"delete\"]],\"sidebar.sections.custom.delete\",\"sidebar.sections.custom.delete\"]],null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"transformedModel\",\"sectionType\"]],[[[1,\"      \"],[8,[39,12],[[24,0,\"btn-flat btn-text reset-link\"]],[[\"@action\",\"@icon\",\"@title\",\"@label\",\"@ariaLabel\"],[[30,0,[\"resetToDefault\"]],\"undo\",\"sidebar.sections.custom.links.reset\",\"sidebar.sections.custom.links.reset\",\"sidebar.sections.custom.links.reset\"]],null],[1,\"\\n\"]],[]],null],[1,\"  \"]],[]]]]]],[\"@closeModal\",\"link\",\"link\"],false,[\"d-modal\",\"i18n\",\"unless\",\"input\",\"on\",\"with-event-value\",\"fn\",\"mut\",\"if\",\"each\",\"-track-array\",\"sidebar/section-form-link\",\"d-button\",\"not\",\"and\",\"d-tooltip\",\"d-icon\"]]",
  "moduleName": "discourse/components/modal/sidebar-section-form.hbs",
  "isStrictMode": false
});